<template>

    <CRow>
        <CCol col="12" lg="10">
            <CCard>
                <CCardHeader>
                    <strong>{{ dish.title }}</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <CNav variant="tabs">
                        <CNavItem active>
                            Карточка
                        </CNavItem>
                        <CNavItem
                            v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly) || (restaurant.alias && adminOnly)" 
                            :to="`/restaurants/${restaurant.id}/dishes/${dish.id}/edit`">
                            Редактировать
                        </CNavItem>
                        <CNavItem :to="`/restaurants/${restaurant.id}/dishes/${dish.id}/ingredient-groups`">
                            Группы ингредиентов
                        </CNavItem>
                        <CNavItem :to="`/restaurants/${restaurant.id}/dishes/${dish.id}/modifier-groups`">
                            Группы модификаторов
                        </CNavItem>
                    </CNav>
                    <CRow class="pl-3 pb-3" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Название</CCol>
                        <CCol sm="9" class="col-form-label">{{ dish.title }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Скидка</CCol>
                        <CCol sm="9" class="col-form-label">{{ getPromotion }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Категории</CCol>
                        <CCol
                            sm="9"
                            class="col-form-label"
                            :title="categories">{{ cutCategories(categories) }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Лейблы</CCol>
                        <CCol sm="9" class="col-form-label">
                        <div v-if="dishLabels && dishLabels.length">
                            <CBadge
                            v-for="label in dishLabels"
                            :key="label.id"
                            color="primary"
                            class="mr-1"
                            >
                            {{ label.title }}
                            </CBadge>
                        </div>
                        <div v-else>
                            Нет лейблов
                        </div>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Внешний ID</CCol>
                        <CCol sm="9" class="col-form-label">{{ dish.external_id }}</CCol>
                    </CRow>
                    <DishSchedule v-if="dish.id" :schedules="dish.schedules" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureUrl"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>

                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Описание</CCol>
                        <CCol sm="9" class="col-form-label">{{ dish.description }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Количество (шт)</CCol>
                        <CCol sm="9" class="col-form-label">{{ dish.quantity }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Состав</CCol>
                        <CCol sm="9" class="col-form-label">{{ dish.composition }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Содержит</CCol>
                        <CCol sm="9" class="col-form-label">{{ dish.allergens }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Цена</CCol>
                        <CCol sm="9" class="col-form-label">{{ dish.price }}</CCol>
                    </CRow>

                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Значения ставки НДС</CCol>
                        <CCol sm="9" class="col-form-label">{{ vat }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Вес ({{ UNITS_ENUM[dish.units] }})</CCol>
                        <CCol sm="9" class="col-form-label">{{ dish.weight }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Калории</CCol>
                        <CCol sm="9" class="col-form-label">{{ dish.calories }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Белки</CCol>
                        <CCol sm="9" class="col-form-label">{{ formatMacro(dish.protein) }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Жиры</CCol>
                        <CCol sm="9" class="col-form-label">{{ formatMacro(dish.fat) }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Углеводы</CCol>
                        <CCol sm="9" class="col-form-label">{{ formatMacro(dish.carbohydrates) }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Подборки для стола заказов</CCol>
                        <CCol sm="9" class="col-form-label">
                            <div>Завтрак:
                                <CBadge :color="getBadge(dish.table_order_breakfast)">
                                    &nbsp;{{ dish.table_order_breakfast ? 'Да' : 'Нет' }}&nbsp;
                                </CBadge>
                            </div>
                            <div>Обед:
                                <CBadge :color="getBadge(dish.table_order_lunch)">
                                    &nbsp;{{ dish.table_order_lunch ? 'Да' : 'Нет' }}&nbsp;
                                </CBadge>
                            </div>
                            <div>Ужин:
                                <CBadge :color="getBadge(dish.table_order_dinner)">
                                    &nbsp;{{ dish.table_order_dinner ? 'Да' : 'Нет' }}&nbsp;
                                </CBadge>
                            </div>
                            <div>Перекус:
                                <CBadge :color="getBadge(dish.table_order_snack)">
                                    &nbsp;{{ dish.table_order_snack ? 'Да' : 'Нет' }}&nbsp;
                                </CBadge>
                            </div>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Энергетик (18+)</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(dish.energetic)">
                                &nbsp;{{ dish.energetic ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Популярный</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(dish.popular)">
                                &nbsp;{{ dish.popular ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Активен</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(dish.enabled)">
                                &nbsp;{{ dish.enabled ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="goBack">Назад</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

    </CRow>
</template>

<script>
    import Vue from 'vue';
    import { UNITS_ENUM } from '@/utils/units';
    import DishSchedule from '@/components/dish-schedule.vue';

    export default {

        name: 'Restaurant',

        components: {
            DishSchedule
        },

        data () {
            return {
                restaurant: {},
                dish: {},
                categories: '',
                UNITS_ENUM,
                labels: [],
                dishLabels: [],
                vatOptions: [
                    { value: null, label: 'НДС не облагается' },
                    { value: 0, label: 'НДС 0%' },
                    { value: 5, label: 'НДС 5%' },
                    { value: 7, label: 'НДС 7%' },
                    { value: 10, label: 'НДС 10%' },
                    { value: 20, label: 'НДС 20%' },
                    { value: 22, label: 'НДС 22%' },
                    { value: 105, label: 'Расчетный НДС 5/105' },
                    { value: 107, label: 'Расчетный НДС 7/107' },
                    { value: 110, label: 'Расчетный НДС 10/110' },
                    { value: 120, label: 'Расчетный НДС 20/120' },
                    { value: 12, label: 'НДС 12% (только для онлайн-касс в Казахстане)' },
                ],
            }
        },

        computed: {
            vat() {
                return this.vatOptions.find(item => item.value === this.dish.vat).label;
            },
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
            pictureUrl() {
                if(this.restaurant.picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.dish.picture;
                } else {
                    return '';
                }
            },
            getPromotion: function() {
                const promotionsOptions = [];
                let promotion = '';
                if(this.promotions) {
                    this.promotions.forEach(promotion => {
                        promotionsOptions.push({
                            value: promotion.id,
                            label: promotion.title
                        });
                    })
                    for (const prom of promotionsOptions) {
                        if(prom.value === this.dish.promotion_id){
                            promotion = prom.label
                        }
                    }
                }
                return promotion;
            },
        },

        mounted() {
            const id = parseInt(this.$route.params.id);
            const dish_id = parseInt(this.$route.params.dish_id);
            Vue.axios.get('/common-promotions')
                .then(resp => {
                    this.promotions = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });

            Vue.axios.get('/labels')
                .then((resp) => {
                    this.labels = resp.data;
                    this.fetchDish(id, dish_id);
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки лейблов.');
                });
            Vue.axios.get('/restaurants/' + id)
                .then(resp => {
                    this.restaurant = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios.get('/restaurants/' + id + '/dishes/get-categories/' + dish_id)
                .then(resp => {
                    this.categories = resp.data.map(cat => cat.title).join(', ');
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },
        methods: {
            formatMacro(value) {
                const n = Number(value);
                if (!Number.isFinite(n)) return '0.0';
                return (Math.round((n + Number.EPSILON) * 10) / 10).toFixed(1);
            },
            goBack() {
                this.$router.push({ path: '/restaurants/' + this.restaurant.id + '/dishes' })
            },
            getBadge (status) {
                return status ? 'success' : 'secondary';
            },
            cutCategories(categories) {
                return categories.length > 29 ? `${categories.slice(0, 30)}...` : categories;
            },
            loadDishLabels() {
                if (this.dish.labels && this.dish.labels.length) {
                    this.dishLabels = this.labels.filter((label) =>
                    this.dish.labels.includes(label.id)
                    );
                } else {
                    this.dishLabels = [];
                }
            },
            fetchDish(restaurantId, dishId) {
                Vue.axios.get('/restaurants/' + restaurantId + '/dishes/' + dishId)
                    .then((resp) => {
                        this.dish = resp.data;
                        this.loadDishLabels();
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
            },
        }
    }

</script>
<style scoped lang="scss">

</style>
